<div role="document">
  <div>
    <h2 id="prep-file-heading">Creation Coupon</h2>
  </div>

  <div class=" justify-content-center">
    <form name="editForm" role="form" novalidate (ngSubmit)="f.form.valid && save()" [formGroup]="couponCreateForm"
      #f="ngForm">
        <fieldset class="border p-2">
          <legend class="w-auto">Coupon</legend>
          <div class="form-row mb-2">
            <div class="col-4">
              <label for="expirationDate">Date d'expiration</label>
              <input type="date" class="form-control" id="expirationDate" name="expirationDate" [ngClass]="{ 'forminput-invalid':
              f.submitted && couponCreateForm?.controls?.expirationDate?.errors != null}" formControlName="expirationDate"/>
              <div *ngIf="f.submitted && couponCreateForm?.controls?.expirationDate?.errors" class="text-danger">
                champ Obligatoire
              </div>
            </div>
            <div class="col-6">
              <label class="form-control-label" for="adresse">Temps  : </label>
                <div class="col-6">
                  <ngb-timepicker class="mb-2" formControlName="TimeStart"></ngb-timepicker>
                </div>
            </div>

          </div>
      </fieldset>
      <fieldset class="border p-2">
        <legend class="w-auto">Note</legend>
        <div class="form-row mb-2">
          <div class="col-12">
            <textarea type="text" class="form-control" id="note" row="10" name="note"
            [ngClass]="{ 'forminput-invalid':
            f.submitted && couponCreateForm?.controls?.note?.errors != null}" formControlName="note" >
            </textarea>
            <div *ngIf="f.submitted && couponCreateForm?.controls?.note?.errors" class="text-danger">
              champ Obligatoire
            </div>

          </div>

        </div>
        </fieldset>
      <div class="m-2">
        <button type="button" id="cancel-save" class="btn btn-secondary" data-dismiss="modal"
          [routerLink]="['/coupons']">
          &nbsp;<span>Annuler</span>
        </button>
        &nbsp;&nbsp;
        <button type="submit" id="save-entity" class="btn btn-indigo">
          <span>Valider</span>
        </button>
      </div>
    </form>
  </div>
</div>
